import React, {useEffect, useState, FC} from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import DialogTitle from "@mui/material/DialogTitle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {getOrientation, resetOrientation} from "../../lib/util";
import {useTranslation} from "next-i18next";
import useWidth from "../../hooks/use-width";
import {TransitionProps} from "@mui/material/transitions";
import Slide from "@mui/material/Slide";
import {firestore, storage} from "../../lib/firebase";
import {getDocs, collection} from "firebase/firestore";
import {ref} from "@firebase/storage";
import {PhotoCropAndUploadDialog} from "../photo-crop-and-upload-dialog";
import {useSelector} from "../../store";


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface CoverPhotoItem {
    title: string
    author: string
    url:string
}


interface CoverPhotoPickerProps {
    open: boolean
    onFinished: (file: string | null) => void


}

export const CoverPhotoPicker: FC<CoverPhotoPickerProps> = ({onFinished, open}) => {

    const {t} = useTranslation();

    const {isUpdatingProfile, currentProfile: {uid}} = useSelector((state) => state.userSession);


    const [src, setSrc] = useState(null);

    const [coverPhotoArray, setCoverPhotoArray] = useState<CoverPhotoItem[]>([]);

    const photoInputRef = React.useRef<HTMLInputElement>(null);

    const width = useWidth()

    const fullscreen = width == "xs"

    //const embeddedProfile = useSelector(state => state.embeddedProfile);

    const populateDisplay = async () => {


        const coverPhotosSnap = await getDocs(collection(firestore, `cover_photos`))


        const newArray: CoverPhotoItem[] = [];

        for (const doc of coverPhotosSnap.docs) {
            const url =
                "https://firebasestorage.googleapis.com/v0/b/" +
                ref(storage).bucket +
                "/o/" +
                encodeURIComponent("cover_photos/" + doc.data().file + "/1920.webp") +
                "?alt=media";

            newArray.push({
                title: doc.data().title,
                author: doc.data().author,
                url
            });
        }

        setCoverPhotoArray(newArray);
    };

    useEffect(() => {
        populateDisplay();
    }, []);

    const onSelectFile = (e: any) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.addEventListener(
                "load",
                () =>
                    getOrientation(file, orientaitonCode => {
                        resetOrientation(reader.result || "", orientaitonCode, rotatedDataUrl => {
                            setSrc(rotatedDataUrl);
                        });
                    }),
                false
            );
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    const onSelected = (mySrc: any) => {
        //console.log("onselected: ", mySrc);

        if (photoInputRef.current) photoInputRef.current.value = "";
        setSrc(null);

        onFinished(mySrc);
    };

    return (
        <Dialog
            fullScreen={fullscreen}
            open={!!open}
            onClose={(event, reason) => {
                onFinished(null);
            }}
            TransitionComponent={Transition}
        >
            <DialogTitle>
                {t("choose-cover-photo-title")}

                <form>
                    <input
                        ref={photoInputRef}
                        accept="image/*"
                        id="raised-button-cover-file"
                        type="file"
                        style={{display: "none"}}
                        onChange={onSelectFile}
                    />
                    <label htmlFor="raised-button-cover-file">
                        <Button
                            variant="contained"
                            component="span"
                            sx={{mt:4}}
                            onClick={e => {
                                e.preventDefault();
                                photoInputRef.current?.click();
                            }}
                            endIcon={<CloudUploadIcon/>}
                        >
                            {t("upload")}

                        </Button>
                    </label>
                </form>
                <PhotoCropAndUploadDialog
                  src={src}
                  onFinished={onSelected}
                  storageDestination={`user/${uid}/profile/cover_photo_${uid}.jpg`}
                  aspect={3}
                  circularCrop={false}
                />
            </DialogTitle>
            <DialogContent>
                <ImageList rowHeight={180} sx={{width: "100%", height: "100%"}}>
                    {coverPhotoArray.map(tile => (
                        <ImageListItem
                            key={tile.url}
                            style={{cursor: "pointer"}}
                            onClick={e => {
                                onSelected(tile.url);
                            }}
                        >
                            <img src={tile.url} alt={tile.title}/>
                            <ImageListItemBar subtitle={<span>by: {tile.author}</span>}/>
                        </ImageListItem>
                    ))}
                </ImageList>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={e => {
                        onFinished(null);
                    }}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}
